import customerLogosRetina from 'marketing-website/media/images/pages/pricing/logos@2x.png';
import studentsRetina from 'marketing-website/media/images/pages/pricing/students-new@2x.png';
import nonprofitRetina from 'marketing-website/media/images/pages/pricing/nonProfit-new@2x.png';
import patternRetina from 'marketing-website/media/images/pages/pricing/pattern@2x.png';
import faq from 'marketing-website/media/images/pages/pricing/faq@2x.png';

const assets = {
  customerLogos: {
    alt: 'Join thousands of companies innovating faster with Marvel',
    src: customerLogosRetina,
    maxWidth: 556,
  },
  students: {
    alt: 'Marvel for Students and Teachers',
    src: studentsRetina,
    maxWidth: 175,
  },
  nonprofit: {
    alt: 'Marvel for Non-Profits',
    src: nonprofitRetina,
    maxWidth: 175,
  },
  patternRetina: {
    alt: 'pattern',
    src: patternRetina,
    maxWidth: 600,
  },
  faq: {
    alt: 'Woman smiling in a crowd',
    src: faq,
    maxWidth: 332,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/pricing/assets.js